import './App.css';
import NftArea from './nft-area'
import artImage1 from './assets/punks-4462.png'
import artImage1Actual from './assets/actual-punks-4462.png'
import artImage2 from './assets/bayc-1050.png'
import artImage2Actual from './assets/actual-bayc-1050.png'
import artImage3 from './assets/azuki-753.png'
import artImage3Actual from './assets/actual-azuki-753.png'

import artWood from './assets/wood.png'
import artWood2 from './assets/wood2.png'
import artColored from './assets/colored.png'
import artGradient from './assets/gradient.png'
import artGold from './assets/gold.png'
import artDiamond from './assets/diamond.png'
import artRainbow from './assets/rainbow.png'

import bg from './assets/bg.jpg'

function App() {
  return (
    <div className="App">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="first-col flex-1 p-4 lg:p-16 text-left pt-32 lg:pt-44 text-white bg-stone-900 bg-no-repeat bg-top bg-contain order-2 lg:order-1" style={{ backgroundImage: `url(${ bg })` }}>

          <nav className="absolute top-8 left-16 right-16 flex justify-center lg:justify-start gap-4">
            <a className="btn btn-square btn-link" href="https://opensea.io/collection/pikzels">
              <svg className="text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" fill="none">
                <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
              </svg>
            </a>
            <a className="btn btn-square btn-link" href="https://etherscan.io/address/0x39e51016334f5888aed3ea03a05310ff41e18596">
              <svg className="text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293.775 293.667">
                <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
                  <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" fill="#fff"/>
                  <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
                </g>
              </svg>
            </a>
            <a className="btn btn-square btn-link" href="https://twitter.com/PikzelsNFT">
              <svg className="text-white" viewBox="4 4 60 60" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.167,22.283c-2.619,0.953-4.274,3.411-4.086,6.101  l0.063,1.038l-1.048-0.127c-3.813-0.487-7.145-2.139-9.974-4.915l-1.383-1.377l-0.356,1.017c-0.754,2.267-0.272,4.661,1.299,6.271  c0.838,0.89,0.649,1.017-0.796,0.487c-0.503-0.169-0.943-0.296-0.985-0.233c-0.146,0.149,0.356,2.076,0.754,2.839  c0.545,1.06,1.655,2.097,2.871,2.712l1.027,0.487l-1.215,0.021c-1.173,0-1.215,0.021-1.089,0.467  c0.419,1.377,2.074,2.839,3.918,3.475l1.299,0.444l-1.131,0.678c-1.676,0.976-3.646,1.526-5.616,1.567  C20.775,43.256,20,43.341,20,43.405c0,0.211,2.557,1.397,4.044,1.864c4.463,1.377,9.765,0.783,13.746-1.568  c2.829-1.674,5.657-5,6.978-8.221c0.713-1.715,1.425-4.851,1.425-6.354c0-0.975,0.063-1.102,1.236-2.267  c0.692-0.678,1.341-1.419,1.467-1.631c0.21-0.403,0.188-0.403-0.88-0.043c-1.781,0.636-2.033,0.551-1.152-0.402  c0.649-0.678,1.425-1.907,1.425-2.267c0-0.063-0.314,0.042-0.671,0.233c-0.377,0.212-1.215,0.53-1.844,0.72l-1.131,0.361l-1.027-0.7  c-0.566-0.381-1.361-0.805-1.781-0.932C40.766,21.902,39.131,21.944,38.167,22.283z M34,64C17.432,64,4,50.568,4,34  C4,17.431,17.432,4,34,4s30,13.431,30,30C64,50.568,50.568,64,34,64z"/>
              </svg>
            </a>
          </nav>

          <h2 className="text-6xl mb-0">Pikzels</h2>
          <p className="mb-16 text-secondary text-xs">Created by <a className="font-bold" href="https://devdad.xyz">DEVDAD</a></p>
          <p className="mb-4 text-accent">The culmination of NFT art appreciation</p>
          <p className="mb-16 text-xl font-bold">Each Pikzel is an algorithmically crafted work of art. A homage to the various amazing collections such as BAYC, Punks, CloneX, Doodles, Azuki, and Mfers.</p>

          <div className="stats stats-vertical xl:stats-horizontal text-white">
            <div className="stat">
              <div className="stat-value">5,000</div>
              <div className="stat-title">Total Supply</div>
            </div>
            <div className="stat">
              <div className="stat-value">5.0%</div>
              <div className="stat-title">Royalty</div>
            </div>
            <div className="stat">
              <div className="stat-value">0Ξ</div>
              <div className="stat-title">First Mint</div>
            </div>
            <div className="stat">
              <div className="stat-value">0.0025Ξ</div>
              <div className="stat-title">Rest Mint Price</div>
            </div>
          </div>

          <svg className="fill-white w-6 animate-bounce mx-auto my-32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M154.3 509.7c3.125 3.125 8.188 3.125 11.31 0l152-152C319.2 356.1 320 354.1 320 352s-.7813-4.094-2.344-5.656c-3.125-3.125-8.188-3.125-11.31 0L168 484.7V8C168 3.594 164.4 0 160 0S152 3.594 152 8v476.7l-138.3-138.3c-3.125-3.125-8.188-3.125-11.31 0s-3.125 8.188 0 11.31L154.3 509.7z"/></svg>

          <h2 className="text-4xl mb-4">The NFT Art</h2>
          <p className="mb-16">Based on artworks from the aforementioned collections, our <em>super (duper)</em> complex algorithm takes the NFT, then compresses them into a single unit.. an NFT singularity if you will. The resulting unique piece contains all the essence of the original artwork, but in a very concentrated state.</p>

          <div className="mx-auto flex justify-evenly items-center mb-16 flex-col md:flex-row">
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage1Actual } alt="CryptoPunk #4461"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">CryptoPunk #4461</div>
            </div>
            <svg className="w-6 fill-white my-8 rotate-90 md:rotate-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M509.7 261.7c3.125-3.125 3.125-8.188 0-11.31l-152-152C356.1 96.78 354.1 95.1 352 95.1s-4.094 .7813-5.656 2.344c-3.125 3.125-3.125 8.188 0 11.31l138.3 138.3H8c-4.406 0-8 3.578-8 8C0 260.4 3.594 263.1 8 263.1h476.7l-138.3 138.3c-3.125 3.125-3.125 8.188 0 11.31s8.188 3.125 11.31 0L509.7 261.7z"/></svg>
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage1 } alt="Pikzel NFT"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Pikzel of CryptoPunk #4461</div>
            </div>
          </div>

          <div className="mx-auto flex justify-evenly items-center mb-16 flex-col md:flex-row">
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage2Actual } alt="Bored Ape #1050"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Bored Ape #1050</div>
            </div>
            <svg className="w-6 fill-white my-8 rotate-90 md:rotate-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M509.7 261.7c3.125-3.125 3.125-8.188 0-11.31l-152-152C356.1 96.78 354.1 95.1 352 95.1s-4.094 .7813-5.656 2.344c-3.125 3.125-3.125 8.188 0 11.31l138.3 138.3H8c-4.406 0-8 3.578-8 8C0 260.4 3.594 263.1 8 263.1h476.7l-138.3 138.3c-3.125 3.125-3.125 8.188 0 11.31s8.188 3.125 11.31 0L509.7 261.7z"/></svg>
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage2 } alt="Pikzel NFT"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Pikzel of Bored Ape #1050</div>
            </div>
          </div>

          <div className="mx-auto flex justify-evenly items-center mb-32 flex-col md:flex-row">
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage3Actual } alt="Azuki #753"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Azuki #753</div>
            </div>
            <svg className="w-6 fill-white my-8 rotate-90 md:rotate-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M509.7 261.7c3.125-3.125 3.125-8.188 0-11.31l-152-152C356.1 96.78 354.1 95.1 352 95.1s-4.094 .7813-5.656 2.344c-3.125 3.125-3.125 8.188 0 11.31l138.3 138.3H8c-4.406 0-8 3.578-8 8C0 260.4 3.594 263.1 8 263.1h476.7l-138.3 138.3c-3.125 3.125-3.125 8.188 0 11.31s8.188 3.125 11.31 0L509.7 261.7z"/></svg>
            <div className="text-center">
              <div className="avatar">
                <div className="w-64 rounded">
                  <img src={ artImage3 } alt="Pikzel NFT"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Pikzel of Azuki #753</div>
            </div>
          </div>

          <h2 className="text-4xl mb-4">Rarity</h2>
          <p className="mb-16">Each Pikzel is an artwork, IRL typically you frame rare artworks differently from fashion artwork. Taking this as inspiration, each Pikzel comes with its own frame that signifies its rarity. <strong>Wood</strong> is the most common frame, followed by <strong>colored</strong> and <strong>gradient</strong> ones. The very rare and special frames come in <strong>gold</strong>, <strong>diamond</strong> and <strong>rainbow</strong>.</p>

          <div className="mx-auto flex justify-evenly mb-8 gap-8 flex-wrap">
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artWood } alt="Wood frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Wood frame</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artWood2 } alt="Wood frame #2"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Wood frame #2</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artColored } alt="Colored frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Colored frame</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artGradient } alt="Gradient frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Gradient frame</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artGold } alt="Gold frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Gold frame</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artDiamond } alt="Diamond frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Diamond frame</div>
            </div>
            <div className="text-center">
              <div className="avatar">
                <div className="w-32 rounded">
                  <img src={ artRainbow } alt="Rainbow frame"/>
                </div>
              </div>
              <div className="text-sm text-center text-accent">Rainbow frame</div>
            </div>
          </div>
        </div>

        <div className="flex-1 flex justify-center items-center lg:h-screen p-4 lg:p-16 order-1 lg:order-2 pt-32 lg:pt-16 pb-16 text-white">
          <div className="lg:fixed">
            <h2 className="text-4xl mb-2">Mint Now</h2>
            <p className="mb-16">First is free, 0.0025 eth each after, max 10 per wallet</p>
            <NftArea />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
